'use client';

import { useEffect, useState } from 'react';

interface CalculatorHeroProps {
  language: 'en' | 'es';
}

const CalculatorHero = ({ language }: CalculatorHeroProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const content = {
    en: {
      headline: "What\'s Your Current Structure Costing You?",
      subhead: 'Calculate your opportunity cost in 2 minutes.',
    },
    es: {
      headline: '¿Cuánto Te Cuesta Tu Estructura Actual?',
      subhead: 'Calcula el costo de oportunidad en 2 minutos.',
    },
  };

  return (
    <section className="pt-32 pb-12 px-6">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className={`space-y-4 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-foreground">
            {content[language].headline}
          </h1>
          <p className="text-xl text-muted-foreground">
            {content[language].subhead}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CalculatorHero;